(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-page-rebuild"]) return;
  try {
    
  (() => {
    const selector = '[data-about-reveal]';

    const reveal = (scope) => {
      const nodes = scope.querySelectorAll(selector);
      if (!nodes.length) return;

      if (!('IntersectionObserver' in window)) {
        nodes.forEach((node) => node.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries, io) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          });
        },
        {
          threshold: 0.18,
          rootMargin: '0px 0px -8% 0px'
        }
      );

      nodes.forEach((node) => observer.observe(node));
    };

    const init = () => {
      document.querySelectorAll('.about-page-rebuild').forEach((section) => reveal(section));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (!event.target) return;
      const section = event.target.querySelector('.about-page-rebuild');
      if (section) reveal(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agencies-page-impact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const frameState = new WeakMap();

    const syncImpactFocus = (frame) => {
      const cards = Array.from(frame.querySelectorAll('.agencies-page-impact__card'));
      if (!cards.length) return;

      const frameRect = frame.getBoundingClientRect();
      if (frameRect.width <= 0) return;

      const frameCenter = frameRect.left + frameRect.width / 2;
      const maxDistance = Math.max(frameRect.width / 2, 1);
      let activeCard = null;
      let closestDistance = Number.POSITIVE_INFINITY;

      cards.forEach((card) => {
        const rect = card.getBoundingClientRect();
        const cardCenter = rect.left + rect.width / 2;
        const distance = Math.abs(frameCenter - cardCenter);
        const focus = Math.max(0, 1 - distance / maxDistance);

        card.style.setProperty('--impact-card-focus', focus.toFixed(4));

        if (distance < closestDistance) {
          closestDistance = distance;
          activeCard = card;
        }
      });

      cards.forEach((card) => {
        card.classList.toggle('is-impact-active', card === activeCard);
      });
    };

    const stopImpactFocus = (frame) => {
      const state = frameState.get(frame);
      if (state && state.rafId) {
        window.cancelAnimationFrame(state.rafId);
      }
      frameState.delete(frame);
    };

    const startImpactFocus = (frame) => {
      if (frameState.has(frame)) return;

      const loop = () => {
        syncImpactFocus(frame);
        const state = frameState.get(frame);
        if (!state) return;
        state.rafId = window.requestAnimationFrame(loop);
      };

      frameState.set(frame, { rafId: window.requestAnimationFrame(loop) });
    };

    const initImpactFocus = (root) => {
      root.querySelectorAll('.agencies-page-impact__frame').forEach((frame) => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          stopImpactFocus(frame);
          return;
        }

        syncImpactFocus(frame);
        startImpactFocus(frame);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initImpactFocus(document), { once: true });
    } else {
      initImpactFocus(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initImpactFocus(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.agencies-page-impact__frame').forEach((frame) => {
        stopImpactFocus(frame);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agency-page-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initHeroScrollLinks = (root) => {
      root.querySelectorAll('[data-scroll-link]').forEach((link) => {
        if (link.dataset.ready === 'true') return;
        link.dataset.ready = 'true';

        link.addEventListener('click', (event) => {
          const href = link.getAttribute('href');
          if (!href || !href.startsWith('#')) return;

          const target = document.querySelector(href);
          if (!target) return;

          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initHeroScrollLinks(document), { once: true });
    } else {
      initHeroScrollLinks(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initHeroScrollLinks(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brands-page-cta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const syncBrandsCtaRail = (root = document) => {
      root.querySelectorAll('.brands-page-cta__track').forEach((track) => {
        const duplicateStart = track.querySelector('.brands-page-cta__shot[aria-hidden="true"]');
        if (!duplicateStart) return;
        track.style.setProperty('--brands-cta-rail-sequence-length', `${duplicateStart.offsetLeft}px`);
      });
    };

    const initBrandsCtaRail = () => syncBrandsCtaRail(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBrandsCtaRail, { once: true });
    } else {
      initBrandsCtaRail();
    }

    window.addEventListener('resize', initBrandsCtaRail, { passive: true });
    document.addEventListener('shopify:section:load', (event) => syncBrandsCtaRail(event.target));
    document.addEventListener('shopify:section:reorder', initBrandsCtaRail);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creators-page-cta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const syncCreatorsCtaRail = (root = document) => {
      root.querySelectorAll('.creators-page-cta__track').forEach((track) => {
        const duplicateStart = track.querySelector('.creators-page-cta__shot[aria-hidden="true"]');
        if (!duplicateStart) return;
        track.style.setProperty('--creators-cta-rail-sequence-length', `${duplicateStart.offsetLeft}px`);
      });
    };

    const initCreatorsCtaRail = () => syncCreatorsCtaRail(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCreatorsCtaRail, { once: true });
    } else {
      initCreatorsCtaRail();
    }

    window.addEventListener('resize', initCreatorsCtaRail, { passive: true });
    document.addEventListener('shopify:section:load', (event) => syncCreatorsCtaRail(event.target));
    document.addEventListener('shopify:section:reorder', initCreatorsCtaRail);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const threshold = 10;
    const topLock = 50;

    const initHeader = (header) => {
      if (!header || header.dataset.hideOnScrollInit === 'true') return;
      header.dataset.hideOnScrollInit = 'true';

      const scope = header.parentElement || document;
      const menuToggle = header.querySelector('.site-header__menu-toggle');
      const mobileOverlay = scope.querySelector('.site-header__mobile-overlay');
      const mobileClose = mobileOverlay ? mobileOverlay.querySelector('.site-header__mobile-close') : null;
      const mobileLinks = mobileOverlay ? mobileOverlay.querySelectorAll('.site-header__mobile-link, .site-header__mobile-cta, .site-header__mobile-brand') : [];
      let lastScrollY = window.scrollY || window.pageYOffset || 0;
      let ticking = false;
      let isMenuOpen = false;
      let lockedScrollY = 0;

      const setVisible = (visible) => {
        header.classList.toggle('visible', visible);
        header.classList.toggle('hidden', !visible);
      };

      const setMenuOpen = (open) => {
        isMenuOpen = open;
        header.classList.toggle('is-menu-open', open);

        if (menuToggle) {
          menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          menuToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
        }

        if (mobileOverlay) {
          mobileOverlay.setAttribute('aria-hidden', open ? 'false' : 'true');
          mobileOverlay.classList.toggle('is-open', open);
        }

        if (open) {
          lockedScrollY = window.scrollY || window.pageYOffset || 0;
          document.documentElement.classList.add('is-mobile-menu-open');
          document.body.classList.add('is-mobile-menu-open');
          document.body.style.top = `-${lockedScrollY}px`;
        } else {
          document.documentElement.classList.remove('is-mobile-menu-open');
          document.body.classList.remove('is-mobile-menu-open');
          document.body.style.top = '';
          window.scrollTo(0, lockedScrollY);
        }

        setVisible(true);
      };

      const closeMenu = () => setMenuOpen(false);
      const toggleMenu = () => setMenuOpen(!isMenuOpen);

      const syncOffset = () => {
        document.documentElement.style.setProperty('--site-header-offset', `${header.offsetHeight}px`);
      };

      const update = () => {
        const currentScroll = window.scrollY || window.pageYOffset || 0;

        if (isMenuOpen) {
          setVisible(true);
          lastScrollY = currentScroll;
          return;
        }

        if (currentScroll < topLock) {
          setVisible(true);
          lastScrollY = currentScroll;
          return;
        }

        if (Math.abs(currentScroll - lastScrollY) < threshold) return;

        if (currentScroll > lastScrollY) {
          setVisible(false);
        } else {
          setVisible(true);
        }

        lastScrollY = currentScroll;
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          update();
          ticking = false;
        });
      };

      const onResize = () => {
        syncOffset();

        if (window.innerWidth > 768 && isMenuOpen) {
          closeMenu();
        }
      };

      setVisible(true);
      syncOffset();
      setMenuOpen(false);

      if (menuToggle && mobileOverlay) {
        menuToggle.addEventListener('click', toggleMenu);

        if (mobileClose) {
          mobileClose.addEventListener('click', closeMenu);
        }

        mobileOverlay.addEventListener('click', (event) => {
          if (event.target === mobileOverlay) {
            closeMenu();
          }
        });

        mobileLinks.forEach((link) => {
          link.addEventListener('click', closeMenu);
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && isMenuOpen) {
            closeMenu();
          }
        });
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });
      document.addEventListener('shopify:section:reorder', syncOffset);
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('.site-header').forEach(initHeader);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (!event.target) return;
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hello-world"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const frameState = new WeakMap();
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let resizeRafId = 0;

    const syncRailMetrics = (frame) => {
      const track = frame.querySelector('.evolvant-home__rail-track');
      if (!track) return;

      const cards = Array.from(track.querySelectorAll('.evolvant-home__rail-card'));
      if (!cards.length) return;

      const duplicateStart = cards.find((card) => card.getAttribute('aria-hidden') === 'true');
      if (duplicateStart) {
        track.style.setProperty('--rail-sequence-length', `${duplicateStart.offsetLeft}px`);
        return;
      }

      const gapValue = Number.parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || '0') || 0;
      const totalWidth = cards.reduce((sum, card) => sum + card.offsetWidth, 0);
      const sequenceLength = totalWidth + gapValue * Math.max(cards.length - 1, 0);
      track.style.setProperty('--rail-sequence-length', `${sequenceLength}px`);
    };

    const syncRailFocus = (frame) => {
      const cards = Array.from(frame.querySelectorAll('.evolvant-home__rail-card'));
      if (!cards.length) return;

      const frameRect = frame.getBoundingClientRect();
      if (frameRect.width <= 0) return;

      const frameCenter = frameRect.left + frameRect.width / 2;
      const maxDistance = Math.max(frameRect.width / 2, 1);
      let activeCard = null;
      let closestDistance = Number.POSITIVE_INFINITY;

      cards.forEach((card) => {
        const rect = card.getBoundingClientRect();
        const cardCenter = rect.left + rect.width / 2;
        const distance = Math.abs(frameCenter - cardCenter);
        const focus = Math.max(0, 1 - distance / maxDistance);

        card.style.setProperty('--rail-card-focus', focus.toFixed(4));

        if (distance < closestDistance) {
          closestDistance = distance;
          activeCard = card;
        }
      });

      cards.forEach((card) => {
        card.classList.toggle('is-rail-active', card === activeCard);
      });
    };

    const stopRailFocus = (frame) => {
      const state = frameState.get(frame);
      if (state && state.rafId) {
        window.cancelAnimationFrame(state.rafId);
      }
      frameState.delete(frame);
      frame.dataset.railFocusReady = 'false';
    };

    const startRailFocus = (frame) => {
      if (frame.dataset.railFocusReady == 'true') return;
      frame.dataset.railFocusReady = 'true';
      syncRailMetrics(frame);

      if (prefersReducedMotion.matches) {
        syncRailFocus(frame);
        return;
      }

      const loop = () => {
        if (!document.body.contains(frame)) return;
        syncRailFocus(frame);

        const state = frameState.get(frame) || {};
        state.rafId = window.requestAnimationFrame(loop);
        frameState.set(frame, state);
      };

      loop();
    };

    const getHomesFromRoot = (root) => {
      if (!root) return [];
      if (root instanceof Element && root.matches('.evolvant-home')) return [root];
      if (typeof root.querySelectorAll === 'function') return Array.from(root.querySelectorAll('.evolvant-home'));
      return [];
    };

    const initRailFocus = (root) => {
      root.querySelectorAll('.evolvant-home__story-rail .evolvant-home__rail-frame').forEach((frame) => {
        stopRailFocus(frame);
        syncRailMetrics(frame);
        startRailFocus(frame);
      });
    };

    const initFounderLinks = (root) => {
      getHomesFromRoot(root).forEach((home) => {
        home.querySelectorAll('[data-founder-link]').forEach((card) => {
          if (card.dataset.founderLinkReady === 'true') return;

          const navigate = () => {
            const href = card.getAttribute('data-founder-link');
            if (!href) return;
            window.location.href = href;
          };

          card.addEventListener('click', (event) => {
            if (event.target.closest('a')) return;
            navigate();
          });

          card.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            navigate();
          });

          card.dataset.founderLinkReady = 'true';
        });
      });
    };

    const initHeroToggle = (root) => {
      getHomesFromRoot(root).forEach((home) => {
        const toggleGroup = home.querySelector('[data-hero-toggle-group]');
        if (!toggleGroup || toggleGroup.dataset.heroToggleReady === 'true') return;

        const toggleButtons = Array.from(toggleGroup.querySelectorAll('[data-hero-toggle]'));
        if (!toggleButtons.length) return;

        const setActive = (activeKey) => {
          toggleButtons.forEach((button) => {
            const isActive = button.dataset.heroToggle === activeKey;
            button.classList.toggle('is-active', isActive);
            button.classList.toggle('is-inactive', !isActive);
            button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
        };

        toggleButtons.forEach((button) => {
          button.addEventListener('click', (event) => {
            const activeKey = button.dataset.heroToggle;
            const targetId = button.dataset.heroToggleTarget;
            setActive(activeKey);

            if (!targetId) return;

            const target = home.querySelector(`#${targetId}`) || document.getElementById(targetId);
            if (!target) return;

            event.preventDefault();
            target.scrollIntoView({
              behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
              block: 'start'
            });
          });
        });

        const initialActive = toggleButtons.find((button) => button.dataset.heroToggle === 'creators') || toggleButtons[0];
        setActive(initialActive.dataset.heroToggle);
        toggleGroup.dataset.heroToggleReady = 'true';
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initRailFocus(document);
        initHeroToggle(document);
        initFounderLinks(document);
      }, { once: true });
    } else {
      initRailFocus(document);
      initHeroToggle(document);
      initFounderLinks(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initRailFocus(event.target);
      initHeroToggle(event.target);
      initFounderLinks(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.evolvant-home__story-rail .evolvant-home__rail-frame').forEach((frame) => {
        stopRailFocus(frame);
      });
    });

    window.addEventListener('resize', () => {
      document.querySelectorAll('.evolvant-home__story-rail .evolvant-home__rail-frame').forEach((frame) => {
        syncRailMetrics(frame);
        syncRailFocus(frame);
      });

      if (resizeRafId) {
        window.cancelAnimationFrame(resizeRafId);
      }

      resizeRafId = window.requestAnimationFrame(() => {
        initHeroToggle(document);
        initFounderLinks(document);
        resizeRafId = 0;
      });
    }, { passive: true });

    const handleMotionPreferenceChange = () => {
      document.querySelectorAll('.evolvant-home__story-rail .evolvant-home__rail-frame').forEach((frame) => {
        stopRailFocus(frame);
        syncRailMetrics(frame);
        startRailFocus(frame);
      });
      initHeroToggle(document);
      initFounderLinks(document);
    };

    if (typeof prefersReducedMotion.addEventListener === 'function') {
      prefersReducedMotion.addEventListener('change', handleMotionPreferenceChange);
    } else if (typeof prefersReducedMotion.addListener === 'function') {
      prefersReducedMotion.addListener(handleMotionPreferenceChange);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
